import * as React from 'react';
import { Card, Button, Form, Icon } from 'tabler-react';
import toast from 'cogo-toast';
import PropTypes from 'prop-types';
import Request from '../../shared/request';
import i18n from '../../shared/i18n';

class Tips extends React.Component {
  saveNickname = async () => {
    const data = await Request.call('saveNickname', {
      nickname: this.props.nickname,
    });
    if (data && data.nickname) {
      toast.success(i18n.t('dash-aff-nickupdated'));
    }
  };

  clearNickname = async () => {
    const data = await Request.call('nickname', {
      nickname: '',
    });
    if (data && data.nickname === '') {
      this.props.updateState('nickname', '');
      toast.success(i18n.t('dash-aff-nickcleared'));
    }
  };

  handleCopy = (event, key) => {
    document.querySelector(`[name="copy-${key}"]`).select();
    const success = document.execCommand('copy');
    if (success) {
      toast.info(i18n.t('dash-tip-copyok'));
    } else {
      toast.warn(i18n.t('dash-tip-copyfail'));
    }
  };

  render() {
    return (
      <Card title={i18n.t('dash-aff-linkbtn')}>
        <div className="aff-malus-link">
          <div className="link">
            <div className="item">
              <span className="label">{i18n.t('dash-aff-buylink')}</span>
              <Form.InputGroup>
                <Form.Input
                  readOnly
                  value={
                    this.props.affbuy
                      ? this.props.affbuy
                      : i18n.t('dash-aff-linkalert')
                  }
                  name="copy-buy"
                />
                <Form.InputGroupAppend>
                  <Button
                    RootComponent="button"
                    color="primary"
                    onClick={event => this.handleCopy(event, 'buy')}>
                    {i18n.t('dash-btn-copy')}
                  </Button>
                </Form.InputGroupAppend>
              </Form.InputGroup>
            </div>

            <div className="item">
              <div className="label">
                {i18n.t('buy-aff-nick')} <span>{i18n.t('buy-aff-nicktip')}</span>
                <span className="clear" onClick={() => this.clearNickname()}>
                  {i18n.t('dash-aff-nickclear')}
                  <Icon name="delete" />
                </span>
              </div>
              <Form.InputGroup>
                <Form.Input
                  placeholder={i18n.t('dash-aff-nickplace')}
                  readOnly={!this.props.affid}
                  value={this.props.nickname}
                  onChange={e =>
                    this.props.affid &&
                    this.props.updateState('nickname', e.target.value)
                  }
                />
                <Form.InputGroupAppend>
                  <Button
                    RootComponent="button"
                    color="primary"
                    disabled={!this.props.affid ? 'disable' : ''}
                    onClick={() => this.saveNickname()}>
                    {i18n.t('dash-btn-save')}
                  </Button>
                </Form.InputGroupAppend>
              </Form.InputGroup>
            </div>
          </div>
          <div className="share-content">
            <div className="item">
              <div className="label">{i18n.t('dash-aff-textcopy1')}</div>
              <div className={`content ${!this.props.affid ? 'disable' : ''}`}>
                <textarea
                  readOnly={!this.props.affid}
                  value={
                    this.props.shareText1
                      ? this.props.shareText1
                      : i18n.t('dash-aff-textreview')
                  }
                  name="copy-shareText1"
                  onChange={e =>
                    this.props.updateState('shareText1', e.target.value)
                  }
                />
                <div
                  className="btn btn-copy"
                  onClick={event => this.handleCopy(event, 'shareText1')}>
                  {i18n.t('dash-btn-copy')}
                </div>
              </div>
            </div>
            <div className="item">
              <div className="label">{i18n.t('dash-aff-textcopy2')}</div>
              <div className={`content ${!this.props.affid ? 'disable' : ''}`}>
                <textarea
                  readOnly={!this.props.affid}
                  value={
                    this.props.shareText2
                      ? this.props.shareText2
                      : '审核通过后将生成专属推荐文案'
                  }
                  name="copy-shareText2"
                  onChange={e =>
                    this.props.updateState('shareText2', e.target.value)
                  }
                />
                <div
                  className="btn btn-copy"
                  onClick={event => this.handleCopy(event, 'shareText2')}>
                  {i18n.t('dash-btn-copy')}
                </div>
              </div>
            </div>
          </div>

          <div className="download">
            <span className="label">{i18n.t('dash-aff-resource')}</span>
            <div className="download-list">
              <a
                href="https://getmalus.com/r/aff-download-logo"
                target="_blank"
                rel="noopener noreferrer"
                className="item">
                <Icon name="download-cloud" />
                <span>{i18n.t('dash-aff-resource1')}</span>
              </a>
              <a
                href="https://getmalus.com/r/aff-download-device"
                target="_blank"
                rel="noopener noreferrer"
                className="item">
                <Icon name="download-cloud" />
                <span>{i18n.t('dash-aff-resource2')}</span>
              </a>
              <a
                href="https://getmalus.com/r/aff-download-banner"
                target="_blank"
                rel="noopener noreferrer"
                className="item">
                <Icon name="download-cloud" />
                <span>{i18n.t('dash-aff-resource3')}</span>
              </a>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

Tips.propTypes = {
  affid: PropTypes.string,
  nickname: PropTypes.string,
  shareText1: PropTypes.string,
  shareText2: PropTypes.string,
  updateState: PropTypes.func,
  affbuy: PropTypes.string,
};

export default Tips;
